import type { BookingWorkTimeSlotInput, BookingsWorkTimeSlot } from 'owa-graph-schema';

const mapToBookingWorkTimeSlotInput = (
    timeSlots: BookingsWorkTimeSlot[]
): BookingWorkTimeSlotInput[] => {
    const modifiedTimeSlots: BookingWorkTimeSlotInput[] = timeSlots?.map(timeSlot => {
        const modifiedTimeSlot: BookingWorkTimeSlotInput = {
            start: timeSlot.start,
            end: timeSlot.end,
        };
        return modifiedTimeSlot;
    });
    return modifiedTimeSlots;
};

export default mapToBookingWorkTimeSlotInput;
